class TemplateManifestV1 {
  constructor(data) {
    this.lang = 'en';
    this.version = 1;
    this.name = data.name;
    this.image = data.image;
    this._description = data.description;
    this._usecase = data.usecase;
  }
  get description() {
    return this._description[this.lang];
  }
  get usecase() {
    return this._usecase[this.lang];
  }
  setLanguage(lang) {
    this.lang = lang;
    return this.clone();
  }
  clone() {
    const clone = new TemplateManifestV1({
      name: this.name,
      image: this.image,
      description: this._description,
      usecase: this._usecase
    });
    clone.lang = this.lang;
    return clone;
  }
  get labels() {
    return {
      default: [
        {
          id: 0,
          name: 'Category1',
          labels: [
            {
              id: 0,
              name: 'dog',
              color: '#ff879c'
            },
            {
              id: 1,
              name: 'cat',
              color: '#908eff'
            }
          ]
        },
        {
          id: 1,
          name: 'Category2',
          labels: [
            {
              id: 2,
              name: 'penguin',
              color: '#ffe355'
            },
            {
              id: 3,
              name: 'duck',
              color: '#52ff68'
            }
          ]
        }
      ]
    };
  }
  get optionsSchema() {
    // backward compatible
    return undefined;
  }
  get i18n() {
    // backward compatible
    return undefined;
  }
}
class TemplateManifestV2 {
  constructor(data) {
    this.lang = 'en';
    this.version = data.version;
    this.name = data.name;
    this.image = data.image;
    this.i18n = data.i18n;
    this.optionsSchema = data.optionsSchema;
    this.labels = data.labels;
  }
  get description() {
    var _a;
    return (_a = this.i18n[this.lang]) === null || _a === void 0 ? void 0 : _a.description;
  }
  get usecase() {
    var _a;
    return (_a = this.i18n[this.lang]) === null || _a === void 0 ? void 0 : _a.usecase;
  }
  getOptionTitle(key) {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.i18n[this.lang]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b[key]) === null || _c === void 0 ? void 0 : _c.title;
  }
  getOptionValue(key, value) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = this.i18n[this.lang]) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b[key]) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d[value];
  }
  setLanguage(lang) {
    this.lang = lang;
    return this.clone();
  }
  clone() {
    const clone = new TemplateManifestV2(Object.assign({}, this));
    clone.lang = this.lang;
    return clone;
  }
}
function parseTemplateManifest(data) {
  if (!(data === null || data === void 0 ? void 0 : data.version)) {
    return new TemplateManifestV1(data);
  }
  return new TemplateManifestV2(data);
}

export { TemplateManifestV1 as T, TemplateManifestV2 as a, parseTemplateManifest as p };
